import Messaging from './Messaging';

export default Messaging;
